// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76509471","501":"96bd7378","952":"5bec12b6"}[chunkId] + ".chunk.js";
};